export const SHOP_ITEMS = [
  {
    id: 'click_doubler',
    name: 'ДВОЙНОЙ КЛИК',
    desc: 'Удваивает силу клика',
    icon: '⚡',
    baseCost: 500,
    costMultiplier: 2.5,
    maxLevel: 5,
    effect: (level) => ({ clickMultiplier: Math.pow(2, level) }),
  },
  {
    id: 'pet_speed',
    name: 'СКОРОСТЬ ПИТОМЦА',
    desc: '+2 авто-клика в сек',
    icon: '🐾',
    baseCost: 300,
    costMultiplier: 1.8,
    maxLevel: 10,
    effect: (level) => ({ autoClickFlat: level * 2 }),
  },
  {
    id: 'crit_luck',
    name: 'УДАЧА',
    desc: '+3% к шансу крита',
    icon: '🍀',
    baseCost: 800,
    costMultiplier: 2.2,
    maxLevel: 10,
    effect: (level) => ({ critChanceFlat: level * 0.03 }),
  },
  {
    id: 'combo_hold',
    name: 'ДОЛГОЕ КОМБО',
    desc: 'Комбо держится +1 сек',
    icon: '🔥',
    baseCost: 600,
    costMultiplier: 2,
    maxLevel: 5,
    effect: (level) => ({ comboDurationFlat: level * 1000 }),
  },
  {
    id: 'pet_xp',
    name: 'ВКУСНЫЙ КОРМ',
    desc: '+5 XP питомцу за кормление',
    icon: '🍖',
    baseCost: 400,
    costMultiplier: 1.9,
    maxLevel: 10,
    effect: (level) => ({ petXpFlat: level * 5 }),
  },
  {
    id: 'idle_master',
    name: 'МАСТЕР ОЖИДАНИЯ',
    desc: '+1% авто-дохода за каждый уровень',
    icon: '🌙',
    baseCost: 1500,
    costMultiplier: 2.5,
    maxLevel: 10,
    effect: (level) => ({ autoMultiplier: 1 + level * 0.01 }),
  },
];

export const getShopCost = (item, currentLevel) =>
  Math.floor(item.baseCost * Math.pow(item.costMultiplier, currentLevel));